//* 引入动态icon
import "virtual:svg-icons-register";

//* 引入various组件库指令
import { vLoading } from "various-ui";

//* 引入i18n
import { i18n } from "@/app/i18n";

//* 引入第三方依赖
import useD3 from "./modules/d3";

export default defineNuxtPlugin((nuxtApp) => {
    //* 指令注册
    nuxtApp.vueApp.directive(vLoading.name, vLoading);
    nuxtApp.vueApp.use(i18n);

    //* 获取第三方模块
    const { d3 } = useD3();

    //* 将第三方模块注册项目中
    return { provide: { d3 } };
});
